import styled from "styled-components";
import { MOBILE_WIDTH } from "datastake-daf/src/constants/Style";

const Style = styled.div`
  .ant-btn {
    border-radius: 100px 100px 100px 0;
    padding: 10px;
    height: fit-content;
    font-size: var(--size);
    line-height: var(--size-lg);
    font-weight: 400;
    width: 100%;

    @media (${MOBILE_WIDTH}) {
      padding: 0.8rem 2.625rem;
    }

    &.normal-br {
      border-radius: 8px;
    }

    &.ant-btn-primary {
      background: var(--mmt-primary-70);

      &[disabled] {
        opacity: 0.6;
        color: white;
      }
    }

    &.ant-btn-dark-primary {
      background: #193E61;
      color: white;
    }

    &.ant-btn-default {
      color: var(--mmt-primary-70);
      border: 1.5px solid var(--mmt-primary-70);

      &.default {
        color: #1F2A37;
        border: 1.5px solid #E5E7EB;
      }
    }

    &.cancel {
      background: #1F4A72;
      color: white;
      border-color: transparent;
    }

    &.blue-color {
      color: var(--mmt-primary-70);
      border-color: var(--mmt-primary-70);
    }
  }
`;

export default Style;
